// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/communication/email/v1/email.proto (package stailer_service_specification.communication.email.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/communication/email/v1/email.proto.
 */
const file_stailer_service_specification_communication_email_v1_email = /*@__PURE__*/
  fileDesc("CkBzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jb21tdW5pY2F0aW9uL2VtYWlsL3YxL2VtYWlsLnByb3RvEjRzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jb21tdW5pY2F0aW9uLmVtYWlsLnYxIqUBCgVFbWFpbBKbAQoGc2VuZGVyGAEgASgLMkEuc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uY29tbXVuaWNhdGlvbi5lbWFpbC52MS5FbWFpbFNlbmRlckJIkoIZJOODoeODvOODq+mAgeS/oeiAheOBruioreWumuOBp+OBmeOAgqqCGRjjg6Hjg7zjg6vpgIHkv6HogIXoqK3lrprIghkBInMKC0VtYWlsU2VuZGVyEmQKDGZyb21fYWRkcmVzcxgBIAEoCUJOkoIZMeODoeODvOODq+mAgeS/oeWFg+OCouODieODrOOCue+8iEZyb23vvInjgafjgZnjgIKqghkV6YCB5L+h5YWD44Ki44OJ44Os44K5YgZwcm90bzM", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.communication.email.v1.Email.
 * Use `create(EmailSchema)` to create a new message.
 */
const EmailSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_communication_email_v1_email, 0);

/**
 * Describes the message stailer_service_specification.communication.email.v1.EmailSender.
 * Use `create(EmailSenderSchema)` to create a new message.
 */
const EmailSenderSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_communication_email_v1_email, 1);


exports.file_stailer_service_specification_communication_email_v1_email = file_stailer_service_specification_communication_email_v1_email;
exports.EmailSchema = EmailSchema;
exports.EmailSenderSchema = EmailSenderSchema;
